import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { CandidateServicePath, PAYMENT_EXPECTATIONS } from "utils/constants";
import permissions from "app/permissions";
import ListPaymentExpectations from "./List";

export const resources = {
  isMenu: true,
  icon: <HourglassTopIcon />,
  name: CandidateServicePath + PAYMENT_EXPECTATIONS,
  title: "Очаквани плащания",
  list: <ListPaymentExpectations />,
  permission: permissions.canPreviewPaymentExpectations,
};
